import { motion } from "framer-motion";
import { ShieldCheck, Lock, ClipboardCheck, AlertCircle, Timer, Zap } from "lucide-react";
import { GUARANTEES, COMPLIANCE_STACK } from "@/data/content";

const ICONS = [ShieldCheck, Timer, ClipboardCheck, Lock, Zap, AlertCircle];

export default function Guarantees() {
  return (
    <section
      id="guarantees"
      data-testid="guarantees-section"
      className="border-b border-[#E4E7EC] bg-[#0B111A] text-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <p className="overline mb-4 text-[#FDB022]">§ 03a — Trust stack</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-white sm:text-5xl md:text-6xl">
              Guarantees, in writing.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#98A2B3]">
              Every promise below is written into our forwarder MSA. If we
              miss any of them, you have a contractual remedy — not just an
              apology email.
            </p>

            <div className="mt-10">
              <p className="font-mono-accent mb-4 text-[#FDB022]">COMPLIANCE STACK</p>
              <ul className="grid grid-cols-2 gap-3">
                {COMPLIANCE_STACK.map((c, i) => (
                  <motion.li
                    key={c.label}
                    initial={{ opacity: 0, y: 8 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.3, delay: i * 0.03 }}
                    className="border border-[#1F2937] bg-[#131C2A] p-3"
                    data-testid={`compliance-${i}`}
                    title={c.desc}
                  >
                    <div className="font-display text-sm font-bold tracking-tight text-white">
                      {c.label}
                    </div>
                    <div className="mt-1 text-[11px] leading-relaxed text-[#98A2B3]">
                      {c.desc}
                    </div>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-0 border border-[#1F2937] md:grid-cols-2">
              {GUARANTEES.map((g, i) => {
                const Icon = ICONS[i % ICONS.length];
                return (
                  <motion.article
                    key={g.title}
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.4, delay: i * 0.04 }}
                    className={`bg-[#131C2A] p-6 md:p-7 ${
                      i % 2 === 0 ? "md:border-r md:border-[#1F2937]" : ""
                    } ${i < GUARANTEES.length - 2 ? "border-b border-[#1F2937]" : ""}`}
                    data-testid={`guarantee-${i}`}
                  >
                    <div className="flex items-start gap-3">
                      <span className="flex h-10 w-10 flex-none items-center justify-center border border-[#FDB022] bg-[#FDB022]/10">
                        <Icon className="h-5 w-5 text-[#FDB022]" strokeWidth={2.5} />
                      </span>
                      <div>
                        <h3 className="font-display text-lg font-bold leading-tight tracking-tight text-white">
                          {g.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-[#98A2B3]">
                          {g.body}
                        </p>
                      </div>
                    </div>
                  </motion.article>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
